export const schedules = [
    {
        label: 'Xóa bản ghi khi tắt dịch vụ',
        param: 'DELETE_IF_OFF'
    },
    {
        label: 'Phóng to màn hình khi phát hiện cảnh báo',
        param: 'IS_ZOOM'
    },
    {
        label: 'Bật âm thanh',
        param: 'IS_VOICE'

    },
    {
        label: 'Thời gian lưu trữ AI (Ngày)',
        param: 'TIME_KEEPING_EVENT'

    },
    {
        label: 'Khung giờ cho phép',
        param: 'TIME_ACTIVE'
    },
]